import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';

//styles
import styles from './Groups.module.scss';

//contexts
import { myUserDataContext } from '../../../App';

//functions
import { responseHandler } from '../../../functions/responseHandler';

//dependency
import { Link, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

//shared
import Loading from '../../../shared/Loading';
import ModalYesorNo from '../../../shared/ModalYesorNo';
import MyPagination from '../../../shared/MyPagination';
import ShowNothing from '../../../shared/ShowNothing';
import NewGroupModal from '../../../shared/NewGroupModal';

const Groups = () => {
  const navigate = useNavigate();
  const locations = useLocation().search;
  const myQueryString = queryString.parse(locations);

  const data = useContext(myUserDataContext);
  const { userData, isLogin, setIsLogin } = data;
  const { token, user } = userData;

  const myIdProfile = user.id;

  const [AllGroups, setAllGroups] = useState([]);
  const [isLoad, setIsLoad] = useState(true);
  const [metaPages, setMetaPage] = useState({});
  const [UpdateListGroups, setUpdateListGroups] = useState(false);

  //for make queries
  let joinqueries = [];
  for (let item in myQueryString) {
    if (item === 'page') continue;
    const temp = `${item}=${myQueryString[item]}`;
    joinqueries.push(temp);
  }
  joinqueries = joinqueries.join('&');

  //get all groups
  useEffect(() => {
    setIsLoad(true);
    axios
      .get(
        `/access-group/index?page=${myQueryString.page}${
          joinqueries !== '' ? `&${joinqueries}` : ''
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllGroups(res.data.data);
          setIsLoad(false);
          setMetaPage(res.data.meta);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  }, [UpdateListGroups]);

  const deleteGroupHandler = (id) => {
    axios
      .delete(`/access-group/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        responseHandler(res, 'succ');
        if (res.data.status) {
          setUpdateListGroups(!UpdateListGroups);
          navigate('/dashboard/groups');
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  };

  //for click on any of paginations
  const paginationHandler = (url) => {
    setIsLoad(true);
    axios
      .get(
        `/access-group/index?page=${url}${
          joinqueries !== '' ? `&${joinqueries}` : ''
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAllGroups(res.data.data);
          setIsLoad(false);
          setMetaPage(res.data.meta);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
      });
  };

  if (AllGroups.length) {
    var length = metaPages.links.length;
  }

  const myPath = '/dashboard/groups';
  return !isLoad && isLogin ? (
    AllGroups.length ? (
      <>
        <div className={styles.userContainer}>
          <div className={styles.TopOfTable}>
            <div className={styles.leftTop}>
              <button
                className="btn btn-primary mb-3 ms-2 btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#newGroupModal"
              >
                <i className="bi bi-plus-lg ms-1"></i>
                <span>ایجاد گروه</span>
              </button>
              {/* <Link to="/dashboard/users/trash-list">
                <button className="btn btn-danger mb-3 btn-sm">
                  <i className="bi bi-trash3-fill ms-1"></i>
                  <span>سطل زباله</span>
                </button>
              </Link> */}
            </div>

            <span
              className={styles.InfoCountTable}
            >{`نمایش ${metaPages.from} تا ${metaPages.to} از ${metaPages.total} مورد`}</span>
            <NewGroupModal
              token={token}
              setAllGroups={setAllGroups}
              setUpdateListGroups={setUpdateListGroups}
              UpdateListGroups={UpdateListGroups}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام گروه</th>
                </tr>
              </thead>

              <tbody>
                {AllGroups.map((item, index) => {
                  const iAm = item.id === myIdProfile ? true : false;

                  return (
                    <tr
                      key={index}
                      // className={`${!iAm ? '' : 'table-primary'}`}
                    >
                      <td>{metaPages.from + index}</td>
                      <td>{item.title}</td>

                      <td>
                        <Link
                          to={`/dashboard/group/edite/${item.id}`}
                          style={{ color: '#fff' }}
                        >
                          <button className="btn btn-dark btn-sm mx-1">
                            ویرایش
                          </button>
                        </Link>

                        <button
                          className="btn btn-danger btn-sm mx-1"
                          data-bs-toggle="modal"
                          data-bs-target={`#iam${index}`}
                        >
                          حذف
                        </button>

                        <ModalYesorNo
                          idModal={`iam${index}`}
                          doBtn="حذف"
                          text={`${item.title} حذف شود؟`}
                          Click={() => deleteGroupHandler(item.id)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {length !== 3 && (
            <MyPagination
              meta={metaPages}
              myPath={myPath}
              paginationHandler={paginationHandler}
              joinqueries={joinqueries}
            />
          )}
        </div>
      </>
    ) : (
      <>
        <button
          className="btn btn-primary mb-3 ms-2 btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#newGroupModal"
        >
          <i className="bi bi-plus-lg ms-1"></i>
          <span>ایجاد گروه</span>
        </button>
        <NewGroupModal
          token={token}
          setAllGroups={setAllGroups}
          setUpdateListGroups={setUpdateListGroups}
          UpdateListGroups={UpdateListGroups}
        />
        <ShowNothing text="گروهی برای نمایش وجود ندارد" />
      </>
    )
  ) : (
    <Loading color="#7545fb" />
  );
};

export default Groups;
